import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bar1" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bar2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bar3" }, null, -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "navlinks NormalPaddings" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Etusivu")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Kuulumisia")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Enkeliviesti")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Yksisarvisen viesti")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Henkien viestit")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Tootoo")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Esittely")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Yhteys")
const _hoisted_14 = {
  key: 0,
  class: "menu NormalPaddings"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Etusivu")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Kuulumisia")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Enkeliviesti")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Yksisarvisen viesti")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Henkien viestit")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Tootoo")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Esittely")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Yhteys")

import { reactive } from "vue";
interface State {
  menuOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive<State>({
  menuOpen: false,
});

function toggleMenu(): void {
  state.menuOpen = !state.menuOpen;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["hamburger NormalPaddings", { cross: _unref(state).menuOpen }]),
        onClick: toggleMenu
      }, _hoisted_4, 2),
      _createElementVNode("span", {
        class: "menutitle",
        onClick: toggleMenu
      }, "Valikko"),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/kuulumisia#alku" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/enkeliviesti#viesti" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/yksisarvisviesti#viesti" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/henkienviestit#alku" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/satu#alku" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/#esittely" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/#yhteys" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(state).menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/kuulumisia#alku"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/enkeliviesti#viesti"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/yksisarvisviesti#viesti"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/henkienviestit#alku"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/satu#alku"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/#esittely"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            onClick: toggleMenu,
            to: "/#yhteys"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})